export const STORE_ADMIN_VENUES = 'adminVenuesStore';
export const ADMIN_VENUES_SET_OPTIONS = 'setOptions';
export const ADMIN_VENUES_UPDATE = 'update';
export const ADMIN_VENUES_MERGE = 'merge';
export const ADMIN_VENUES_DEMERGE = 'demerge';
export const ADMIN_VENUES_GET_DATA = 'getVenue';
